import { render, staticRenderFns } from "./ModalExemptStatement.vue?vue&type=template&id=6bfc4f88&"
import script from "./ModalExemptStatement.vue?vue&type=script&lang=js&"
export * from "./ModalExemptStatement.vue?vue&type=script&lang=js&"
import style0 from "./ModalExemptStatement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports